routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.productNotFound', {
      url: __env.routes.productNotFound,
      template: `<product-not-found sh-ctrl="shCtrl"></product-not-found>`,
      params: {
        productSearchText: null
      }
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/product-not-found/product-not-found.config.js
 **/